export default {
  progress: {
    total: 100,
    current: 10,
    default: 10,
  },
  fields: {
    ssn: false,
    birthday: false,
    name: false,
    email: false,
    telephone: false,
    gender: false,
    photoURL: false,
    marital_status: false,
    curriculumURL: false,
    state: false,
    address_number: false,
    address_neighborhood: false,
    city: false,
    address: false,
    formation: false,
    experience: false,
    language: false,
    skill: false
  }
}